import { useState } from 'react';
import {
  AppBar,
  Toolbar,
  IconButton,
  Box,
  Button,
  Drawer,
  List,
  ListItemButton,
  ListItemText,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
// TODO: Replace with actual logo image once available
import logo from '../assets/logo.png';

export default function Header() {
  const [mobileOpen, setMobileOpen] = useState(false);

  const scrollToSection = (id) => {
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
      setMobileOpen(false);
    }
  };

  const navItems = [
    { label: 'Home', id: 'home' },
    { label: 'How This Works', id: 'how-this-works' },
    { label: 'Contact Us', id: 'contact-us' },
    { label: 'Privacy Policy', id: 'privacy-policy' },
  ];

  return (
    <>
      <AppBar
        position="fixed"
        elevation={0}
        sx={{
          backgroundColor: 'rgba(255,255,255,0.95)',
          backdropFilter: 'blur(6px)',
          borderBottom: '1px solid #eee',
        }}
      >
        <Toolbar 
          sx={{ 
            maxWidth: '1200px', 
            width: '100%', 
            mx: 'auto',
            px: { xs: 2, sm: 3, md: 4 },
            justifyContent: 'space-between',
            minHeight: { xs: '64px', md: '72px' },
          }}
        >
          {/* Logo */}
          <Box 
            sx={{ 
              display: 'flex', 
              alignItems: 'center', 
              gap: 1,
              flexShrink: 0,
            }}
          >
            <img 
              src={logo} 
              alt="Spendifyr Logo" 
              style={{ 
                width: 48, 
                height: 48,
                objectFit: 'contain',
              }} 
            />
          </Box>

          {/* Desktop Navigation */}
          <Box
            sx={{
              display: { xs: 'none', md: 'flex' },
              gap: { md: 2, lg: 3 },
              alignItems: 'center',
              ml: 'auto',
            }}
          >
            {navItems.map((item) => (
              <Button
                key={item.id}
                onClick={() => scrollToSection(item.id)}
                sx={{
                  color: '#444',
                  textTransform: 'none',
                  fontSize: '16px',
                  fontWeight: 400,
                  px: { md: 1.5, lg: 2 },
                  py: 1,
                  borderRadius: '6px',
                  transition: 'all 0.2s ease-in-out',
                  '&:hover': { 
                    color: '#2E5E3A',
                    backgroundColor: 'rgba(46, 94, 58, 0.05)',
                  },
                }}
              >
                {item.label}
              </Button>
            ))}
          </Box>

          {/* Mobile Menu Button */}
          <IconButton
            sx={{ 
              display: { md: 'none' }, 
              color: '#444',
              ml: 'auto',
              '&:hover': {
                backgroundColor: 'rgba(46, 94, 58, 0.05)',
              },
            }}
            onClick={() => setMobileOpen(true)}
            aria-label="open menu"
          >
            <MenuIcon />
          </IconButton>
        </Toolbar>
      </AppBar>

      {/* Mobile Drawer */}
      <Drawer 
        anchor="right" 
        open={mobileOpen} 
        onClose={() => setMobileOpen(false)}
        PaperProps={{
          sx: {
            width: { xs: '280px', sm: '320px' },
            boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
          },
        }}
      >
        <Box sx={{ p: 2 }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <img 
                src={logo} 
                alt="Spendifyr Logo" 
                style={{ width: 40, height: 40, objectFit: 'contain' }} 
              />
            </Box>
            <IconButton 
              onClick={() => setMobileOpen(false)}
              sx={{
                color: '#444',
                '&:hover': {
                  backgroundColor: 'rgba(46, 94, 58, 0.05)',
                },
              }}
            >
              <CloseIcon />
            </IconButton>
          </Box>

          <List sx={{ pt: 1 }}>
            {navItems.map((item) => (
              <ListItemButton 
                key={item.id} 
                onClick={() => scrollToSection(item.id)}
                sx={{
                  borderRadius: '8px',
                  mb: 0.5,
                  transition: 'all 0.2s ease-in-out',
                  '&:hover': {
                    backgroundColor: 'rgba(46, 94, 58, 0.08)',
                    '& .MuiListItemText-primary': {
                      color: '#2E5E3A',
                    },
                  },
                }}
              >
                <ListItemText
                  primary={item.label}
                  primaryTypographyProps={{
                    sx: { 
                      color: '#444',
                      fontSize: '16px',
                      fontWeight: 400,
                    },
                  }}
                />
              </ListItemButton>
            ))}
          </List>
        </Box>
      </Drawer>
    </>
  );
}
